import { Modal } from 'antd';
import TenantManager from './TenantManager';

const TenantManagerModal = ({ isModalOpen, setIsTenantsModalOpen }) => {
  const onCancel = () => {
    setIsTenantsModalOpen(false);
  }

  return (
    <>
      <Modal
        title='Manage Tenants'
        open={isModalOpen}
        onCancel={onCancel}
        style={{ top: 20 }}
        width={{
          xs: '95%',
          sm: '95%',
          md: '95%',
          lg: '90%',
          xl: '1200',
        }}
        footer={[]}
      >
        <TenantManager />
      </Modal>
    </>
  );
};

export default TenantManagerModal;